import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';

import useMonitoringBar, { MonitoringBarProps } from 'features/tenants/components/monitoring-bar/hooks';
import styles from './monitoring-bar.module.scss';

const MonitoringBar = ({ monitoring, aggregatedType }: Readonly<MonitoringBarProps>): React.JSX.Element => {
  const { t } = useTranslation('tenants');
  const { monitoringItems } = useMonitoringBar({ monitoring, aggregatedType });

  const renderMonitoringItems = () =>
    monitoringItems.map((item: { type: string; count: number }, i: number) => (
      <div
        data-testid={aggregatedType + item.type + item.count}
        key={`${item.type}-${i}`}
        className={styles[item.type.toLowerCase()]}
        style={{ flexGrow: item.count }}
      />
    ));

  const renderNoData = () => <Typography variant="body2">{t('noAggregateData')}</Typography>;

  return <div className={styles.monitoringBar}>{monitoringItems?.length === 0 ? renderNoData() : renderMonitoringItems()}</div>;
};

export default MonitoringBar;
